import React from "react";
import ReactWOW from "react-wow";
import { Badge, Alert } from "reactstrap";

import PageBreadcrumb from "../Common/PageBreadcrumb";
import center from "../../assets/images/selfcenter/mobile.svg";

const Section = () => {
  return (
    <section className="projects-area">
      <div className="container">
        <div className="row align-items-center">
          <div className="col col-lg-5 col-md-5">
            <img src={center} className="img-fluid" alt="hr软件员工个人中心" />
          </div>
          <div className="col col-lg-7 col-md-7">
            <div className="title-heading mt-4 ml-lg-5">
              <ReactWOW delay=".1s" animation="fadeInLeft">
                <Alert
                  className="alert-pills"
                  role="alert"
                  data-aos="fade-up"
                  data-aos-duration="1000"
                >
                  <Badge color="success" pill className="mr-1">
                    Daren Selfcenter
                  </Badge>
                  <span className="content"> 自助平台</span>
                </Alert>
              </ReactWOW>
              <ReactWOW delay=".1s" animation="fadeInLeft">
                <h1 className="heading mb-3">员工个人中心</h1>
              </ReactWOW>
              <ReactWOW delay=".1s" animation="fadeInLeft">
                <p className="para-desc text-muted">
                  各级管理人员与员工用本人账号密码登录自助平台，查询和处理HR各项业务，员工自主参与管理，驱动组织效率提升。
                </p>
              </ReactWOW>
            </div>
          </div>
        </div>
      </div>
      <PageBreadcrumb
        homePageText="首页"
        homePageUrl="/"
        activePageText="个人中心"
      />

      <div className="position-relative">
        <div className="shape overflow-hidden text-light">
          <svg
            viewBox="0 0 2880 48"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M0 48H1437.5H2880V0H2160C1442.5 52 720 0 720 0H0V48Z"
              fill="currentColor"
            ></path>
          </svg>
        </div>
      </div>
    </section>
  );
};

export default Section;
